export default __webpack_public_path__ + "static/media/decrease.47eed6db.svg";